import * as types from "./mutation-type";

export default {
  [types.SET_SHOW](state, payload) {
    state.show = payload
  },
  [types.SET_MESSAGE](state, payload) {
    state.message = payload
  },
  [types.SET_TIMER](state, payload) {
    state.timer = payload
  },
  [types.SET_ICON](state, payload) {
    state.icon = payload
  },
  [types.SET_THEME](state, payload) {
    state.theme = payload
  },
  [types.SET_SHOW_TOAST_CONFIRM](state, payload) {
    state.showToastConfirm = payload
  },
  [types.SET_CALLBACK_TOAST](state, payload) {
    state.callback = payload
  }
}
